<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Cambiar fecha de vencimiento
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Finanzas</span>
            <span> /</span>
            <span>Cambiar fecha de vencimiento</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
    <div class="card mb-2 wow detalle-cliente">
        <div class="card-body justify-content-between">
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                                  formHeader.get('fechaDesde').invalid &&
                                  (formHeader.get('fechaDesde').dirty ||
                                  formHeader.get('fechaDesde').touched)
                              ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha desde
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                            formControlName="fechaHasta">
                        </mdb-date-picker>
                        <div *ngIf="
                                  formHeader.get('fechaHasta').invalid &&
                                  (formHeader.get('fechaHasta').dirty ||
                                  formHeader.get('fechaHasta').touched)
                              ">
                            <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                                Ingrese fecha hasta
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-select label="Bancos" [options]="optionsBancos" [multiple]="true" placeholder="Bancos"
                            formControlName="bancos" [filterEnabled]="true"></mdb-select>
                    </div>
                </div>
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <input value="" type="text" id="nroCheque" class="form-control" placeholder="XXXXXXXXXX"
                            #nroCheque formControlName="nroCheque" onlyNumbers />
                        <label for="nroCheque">Nro. de cheque</label>
                    </div>
                </div>
                <div class="col" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" class="form-control" placeholder="" formControlName="rut"
                            formatRut />
                        <label for="rutcliente">RUT</label>
                        <div *ngIf="
                                        formHeader.get('rut').invalid &&
                                        (formHeader.get('rut').dirty ||
                                        formHeader.get('rut').touched)
                                      ">
                        </div>
                    </div>
                </div>
                <div class="col d-flex">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="abrirModalSeleccionarCliente()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" *ngIf="clienteSeleccionado" style="display: contents;">
                        {{ clienteSeleccionado.razon_social }}
                    </h6>
                </div>
            </div>

        </div>

        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar
            </button>
        </div>
    </div>
</form>

<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <div class="table-responsive" *ngIf="listaPagos">



            <div *ngIf="listaPagos?.length === 0" #alert class="alert alert-info alert-dismissible fade show m-0"
                role="alert">
                <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <strong>No existen registros!</strong> para los filtros seleccionados.
            </div>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaPagos?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">Nro. Doc.</th>
                        <th scope="col">Banco</th>
                        <th scope="col" class="text-right">Monto</th>
                        <th scope="col">Fecha Venc.</th>
                        <!-- <th scope="col">Nro Cheque</th> -->
                        <!-- <th scope="col">Tipo Doc.</th> -->
                        <th scope="col">RUT</th>
                        <th scope="col">Clientes</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let pago of listaPagos">
                        <td>{{pago.numero_doc}}</td>
                        <td>{{pago.banco_nombre}}</td>
                        <td class="text-right">{{pago.monto | numerico}}</td>
                        <td>{{pago.fecha_vencimiento | fecha}}</td>
                        <!-- <td>{{pago.numero_doc}}</td> -->
                        <!-- <td>FE</td> -->
                        <td>{{pago.cliente_proveedor_rutFormato | rut}}</td>
                        <td>{{pago.cliente_proveedor_nombre}}</td>
                        <td>
                            <span *ngIf="!(estadosPermitidos.includes(pago.estado_codigo))">
                                <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center"
                                    size="sm" (click)="showModalCambioFecha(pago)">
                                    Cambiar fecha
                                </button></span>
                            <span *ngIf="estadosPermitidos.includes(pago.estado_codigo)"></span>
                        </td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaPagos?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<app-cheques-cambiar-fecha-modal-cambiar (onSuccess)="cambioFechaRealizado($event)">
</app-cheques-cambiar-fecha-modal-cambiar>
<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
    queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>